import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import { Action } from '@studiometa/ui';
import LocalizationMenu from './LocalizationMenu.js';
import Menu from './Menu/index.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    refs: ['burger'],
    components: {
      Action,
      Menu,
      LocalizationMenu,
    },
  };

  /**
   *
   */
  mounted() {
    this.mainMenu = this.$children.Menu.find((menu) => menu.$el.id === 'main-menu');
  }

  /**
   *
   */
  onBurgerClick() {
    this.mainMenu.toggleMenuList();
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 80;
    const isSticky = y > 90;

    toggleClass(document.body, 'is-on-top', isOnTop);
    toggleClass(document.body, 'is-near-top', isNearTop);
    toggleClass(document.body, 'is-sticky', isSticky);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.body, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.body, 'is-scrolling-up', direction.y === 'UP');
  }

  /**
   *
   */
  onMenuOpen() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.body, 'is-menu-open', openedMenus.length > 0);
  }

  /**
   *
   */
  onMenuClose() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.body, 'is-menu-open', openedMenus.length > 0);
  }
}
